/**
 * Attribution string for created_by / updated_by writes.
 *
 * A dealer-hash session authenticates a ROOFTOP, not a person — its JWT
 * carries no email claim at all, so reading the claim with a `|| 'unknown'`
 * fallback attributed every embed write to the literal string 'unknown'
 * (issue #1997). Rather than minting a fake email into the token, infer the
 * honest identity here: the real email when a person is behind the session,
 * else the rooftop the hash authenticated.
 */
export function actorIdentity(user: { claims?: object | null } | null | undefined): string {
  const claims = (user?.claims ?? {}) as Record<string, unknown>;
  const email = claims['x-hasura-user-email'];
  if (typeof email === 'string' && email) return email;
  const rooftopId = claims['x-hasura-customer-id'];
  return rooftopId ? `embed:rooftop:${rooftopId}` : 'unknown';
}
